<div *ngIf="!isInitialized" class="app-loading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<router-outlet></router-outlet>
